import type { IconDefinition } from '../../types'

export default {
  details: [32, 32, [], '', 'M32 9V27C32 28.6875 30.625 30 29 30H3C1.3125 30 0 28.6875 0 27V5C0 3.375 1.3125 2 3 2H13L17 6H29C30.625 6 32 7.375 32 9Z'],
  name: 'uiFolderSolid',
  oldName: 'fasFolder'
} as IconDefinition
